import classNames from "classnames";
import { html, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";

import styles from "./mark.css";

export type MarkColor =
  | "black"
  | "blue"
  | "cyan"
  | "green"
  | "orange"
  | "purple"
  | "red"
  | "tan"
  | "turquoise"
  | "violet";

export type MarkVariant =
  | "highlight"
  | "highlight-dark"
  | "highlight-light"
  | "text";

@customElement("bp-mark")
export class Mark extends LitElement {
  static styles = styles;

  @property({ type: Boolean, attribute: "can-spotlight" })
  canSpotlight?: boolean;

  @property()
  color?: MarkColor = "orange";

  @property()
  variant?: MarkVariant = "highlight";

  render() {
    const classes = classNames(this.color, this.variant, {
      "can-spotlight": this.canSpotlight,
    });

    return html`<mark class="${classes}"><slot></slot></mark>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "bp-mark": Mark;
  }
}
